import { render, staticRenderFns } from "./YSJVOFYC.vue?vue&type=template&id=078ef878&scoped=true"
import script from "./YSJVOFYC.vue?vue&type=script&lang=js"
export * from "./YSJVOFYC.vue?vue&type=script&lang=js"
import style0 from "./YSJVOFYC.vue?vue&type=style&index=0&id=078ef878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078ef878",
  null
  
)

export default component.exports